import { Button, Typography } from '@mui/material';
import React, { memo } from 'react';

import styles from './styles.module.scss';

interface Props {
  visible: boolean;
  text: string;
  onClose: () => void;
}

const Component: React.FC<Props> = ({ visible, text, onClose }) => {
  if (!visible) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <div className={styles.banner__content}>
        <Typography color="var(--black-color)" fontWeight="500" lineHeight="19px" variant="body1">
          {text}
        </Typography>
        <Button
          size="small"
          sx={{
            width: '56px',
            minWidth: '56px',
            height: '32px',
            backgroundColor: 'var(--main-2-color)',
            borderRadius: '8px',
            fontSize: '16px',
            lineHeight: '19px',
            fontWeight: '700',
          }}
          onClick={onClose}
        >
          OK
        </Button>
      </div>
    </div>
  );
};

export const EditingBanner = memo(Component);
